// $(document).ready(function () {
//   $(".references-homepage-slider").owlCarousel({
//     items: 1,
//     loop: true,
//     nav: true,
//     dots: false
//   });
// });
